const ClinicarxThemeVariables: Record<string, any> = {
  manufacturer: 'Clinicarx',
  pageTitle: 'Clinicarx - Autoteste COVID',
  backgroundBase: '#36b1ac',
  backgroundDisableButton: '#d9e9e2',
  backgroundBaseFilter:
    "invert(58%) sepia(92%) saturate(299%) hue-rotate(129deg) brightness(86%) contrast(91%)",
  backgroundBaseGradient: "#f9b70f",
  backgroundLoaderResult: "#36b1ac",
  backgroundDaxQRCode: "linear-gradient(to right, #36b1ac, #f9b70f, #36b1ac)",
  backgroundLoaderAnimationStepA: "#36b1ac",
  backgroundLoaderAnimationStepB: "#36b1ac",
  backgroundLoaderAnimationStepC: "#36b1ac",
  backgroundLoaderBar:
    "linear-gradient(90deg, rgba(80, 165, 81, 0) 0%, #50A551 45.16%, rgba(80, 165, 81, 0) 100%)",
  backgroundShareResult: "#F7FCFA",
  backgroundShareScreen: "#F7FCFA",
  ResultShareModal: "#36b1ac",
  backgroundStrongBase: "#f9b70f",
  urlPathLoaderFile: "eco/loader-logo.png",
  urlPathLogoFile: "clinicarx/crx-logo.png",
  urlPathLogoFileWhiteHeader: "clinicarx/crx-logo-white.png",
  urlPathLogoFileCrx: "clinicarx-logo-green.svg",
  urlFavicon: "clinicarx/favicon.png",
  logoWidth: "100px",
  logoHeight: "80px",
  logoWidthWhite: "125px",
  logoHeightWhite: "36.5px",
  logoWhiteTopMargin: "20px",
  logoWidthWhiteDask: "243px",
  logoHeightWhiteDask: "80px",
  testName: "COVID-19 Ag CRX Autoteste",
  urlPathTestImage: "eco/eco-test.png",
  urlPathDocumentIcon: "eco/card-result.png",
  urlVideoGuidelines: "https://www.youtube.com/embed/AvDNXZ5Dm8k?controls=0",
  urlPathQRCode: "vyttra/proxima/qrcode_proximanasal.png",
  socialShareInfo:
    "Acabei de gerar o cartão de resultado do meu Autoteste Clinicarx.",
  totalSteps: 7,
  testStepOneContents: {
    title: "Colete a amostra:",
    steps:
      "<ol> <li>Assoe o nariz e higienize as mãos;</li><li>Abra a embalagem do cotonete (swab);</li>  <li>Insira a ponta com algodão na narina. Gire 5 vezes passando no interior da narina. Repita o procedimento na outra narina com o mesmo swab.</li></ol>",
    image: "eco/nasal/1-colect.gif",
    warningActive: true,
    warningText:
      "Não toque com a sua mão na ponta de algodão do cotonete (swab).",
  },
  testStepTwoContents: {
    title: "Prepare sua amostra para o teste:",
    steps:
      "<ol><li>Pegue o tubo com liquido de diluição;</li><li>Retire o lacre do tubo;</li><li>Insira o swab no tubo;</li><li>Gire o swab nasal pelo menos 10 vezes.</li></ol>",
    image: "eco/nasal/2-prepare.gif",
    warningActive: true,
    warningText:
      "Caso ocorra contato da solução com sua pele ou olhos, lave imediatamente com água.",
  },
  testStepThreeContents: {
    title: "Pingue as gotas no dispositivo:",
    steps:
      "<ol><li>Coloque a tampa conta gotas no tubo;</li><li>Abra o sachê de alumínio e retire o dispositivo teste;</li><li>Pingue 4 gotas da mistura no poço de amostra do dispositivo de teste.</li></ol>",
    image: "eco/nasal/3-drop.gif",
    warningActive: true,
    warningText:
      "Não toque com a sua mão na ponta de algodão do cotonete (swab).",
    timerInMinutes: 1,
  },
  testStepEightContents: {
    title: "Informe os demais dados pessoais",
    warningText:
      "Utilizamos o CPF para reforçar sua identidade no cartão de resultado compartilhável do teste e para seu cadastro com a Clinicarx.",
  },
  logoViewResultCardHeight: '60px',
  logoViewResultCardWidth: '80px',
  testStepFourContents: {
    title: "Informe o resultado do autoteste",
    warningText:
      'A intensidade da cor das linhas no dispositivo podem variar e mesmo os tons mais claros devem ser considerados. <span id="modalLink" style="color: #006ba6; text-decoration: underline;"> Clique aqui se o resultado não mostra a linha “C”.</span>',
  },
  testStepFiveContents: {
    title: "Tire uma foto do resultado do autoteste",
    warningText:
      '<span id="modalLink" style="color: #006ba6; text-decoration: underline;">Ver instruções e exemplo de como tirar a foto.</span>',
  },
  backgrounBaseLinear:
    "linear-gradient(180deg, hsla(178, 53%, 45%, 1) 28%, hsla(178, 53%, 45%, 1) 43%, hsla(57, 68%, 78%, 1) 100%, hsla(218, 88%, 59%, 1) 100%)",

  // Result image variables
  urlNegativeWithoutSymptomsImage: "eco/eco-negative-without-symptons.png",
  heightNegativeWithoutSymptomsImage: "173px",
  widthNegativeWithoutSymptomsImage: "173px",
  urlNegativeWithSymptomsImage: "eco/eco-negative-with-symptons.png",
  heightNegativeWithSymptomsImage: "124px",
  widthNegativeWithSymptomsImage: "122px",
  urlPositiveWithoutSymptomsImage: "eco/eco-positive-without-symptons.png",
  heightPositiveWithoutSymptomsImage: "121px",
  widthPositiveWithoutSymptomsImage: "173px",
  urlPositiveWithSymptomsImage: "eco/eco-positive-with-symptons.png",
  heightPositiveWithSymptomsImage: "124px",
  widthPositiveWithSymptomsImage: "150px",
};

export { ClinicarxThemeVariables };
